module.exports = __webpack_public_path__ + "static/media/eurograndine_logo.0b5103e7.png";